import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './LocusRobotics.frontend.types'

@Injectable({ providedIn: 'root' })
export class LocusRobotics_validate_serialService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { serialNumber: string, material: string, sourceLocationId?: number, packagingId?: number }): Promise<{ message?: string, error?: boolean }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.serialNumber)) {
      missingRequiredInParams.push('\'serialNumber\'');
    }
    if (isNil(inParams.material)) {
      missingRequiredInParams.push('\'material\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

